import useFormContext from "../../../../common/hooks/useFormContext";
import { Typography } from "@mui/material";
import { spacing } from "../../../../styles/theme";
import { Box, FlexColBox, Input } from "../../../../common/components";
import { useTranslation } from "react-i18next";
import { CheckoutForm } from "../../Cart";
import { useAuth } from "../../../../common/hooks/useAuth";
import { CheckoutStyles } from "../styles";

const CartClientDetails = () => {
  const { isAdmin, isDistributor } = useAuth();
  const { formik } = useFormContext();
  const { clientDetails } = formik?.values as CheckoutForm;
  const { t } = useTranslation();
  const formFieldKey = "clientDetails";

  if (!isAdmin && !isDistributor) {
    return null;
  }

  return (
    <FlexColBox
      sx={CheckoutStyles.container}
      gap={{ xs: spacing.groupingMobile, lg: spacing.groupingDesktop }}
    >
      <Typography variant="h2">{t("checkout.client_details.title")}</Typography>
      <Box display="flex" flexDirection="column" gap={"24px"}>
        {isAdmin && (
          <Box display="flex" gap={"12px"}>
            <Input
              name="clientName"
              label={t("checkout.client_details.client_name")}
              subLabel={t("checkout.client_details.in_prextra")}
              value={clientDetails?.clientName}
              onChange={(e: any) =>
                formik?.setFieldValue(
                  `${formFieldKey}.clientName`,
                  e.target.value
                )
              }
              noDefaultValue
            />
            <Input
              name="clientNumber"
              label={t("checkout.client_details.client_number")}
              subLabel={t("checkout.client_details.in_prextra")}
              value={clientDetails?.clientNumber}
              onChange={(e: any) =>
                formik?.setFieldValue(
                  `${formFieldKey}.clientNumber`,
                  e.target.value
                )
              }
              noDefaultValue
            />
          </Box>
        )}
        <Input
          name="clientProjectName"
          label={t("checkout.client_details.client_project_name")}
          value={clientDetails?.clientProjectName}
          onChange={(e: any) =>
            formik?.setFieldValue(
              `${formFieldKey}.clientProjectName`,
              e.target.value
            )
          }
          fullWidth
          noDefaultValue
        />
      </Box>
    </FlexColBox>
  );
};

export default CartClientDetails;
